import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { CONTENT } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "ar");

  const applyLang = useCallback((l) => {
    const dir = CONTENT[l].dir;
    document.documentElement.lang = l;
    document.documentElement.dir = dir;
    localStorage.setItem("lang", l);
  }, []);

  useEffect(() => {
    applyLang(lang);
  }, [lang, applyLang]);

  const toggleLang = () => setLang((prev) => (prev === "ar" ? "en" : "ar"));

  const value = {
    lang,
    setLang,
    toggleLang,
    dir: CONTENT[lang].dir,
    isRTL: CONTENT[lang].dir === "rtl",
    t: CONTENT[lang],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
